module.exports = __webpack_public_path__ + "img/vue-left.cfd9edcf.svg";